var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auto-complete-master-data-select',{attrs:{"display-type":_vm.displayType,"label":_vm.label,"prepared-options":_vm.getOptions,"init-value-id":_vm.value,"watch-value-id":_vm.selectedValue,"on-item-changed":_vm.handleItemSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }